<span class="apps-group-ref" [class.missing]="description?.missing">
  <a [routerLink]="link" target="_blank" rel="noopener" [title]="title">
    <cds-icon shape="node-group" size="14" class="ref-icon"></cds-icon>
    <span class="ref-file">{{ endpoint.file }}</span>
    <span class="ref-separator">›</span>
    <span class="ref-name">{{ endpoint.name }}</span>
    @if (description?.missing) {
      <span class="ref-tag">not found</span>
    } @else if (description?.membersCount != undefined) {
      <span class="ref-count">{{ description.membersCount }}</span>
    }
  </a>
  <ng-content></ng-content>
</span>
